module.exports = ".device-tag {\n  display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/devices/groups/deleteGroupModal.component.scss
// module id = ./src/app/views/devices/groups/deleteGroupModal.component.scss
// module chunks = main